
let config = {
  apiUrl: 'https://api.permacopines.be/',
}
export default config;
